export default {
  default: {
    title: '{global.organizationType.shortName.singular}',
  },
}
